import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useTheme,
  useMediaQuery,
  Typography,
  Grid,
} from '@mui/material';
import { getCompanyData } from 'redux/actions/UserDashboard';

export default function CommonPreviewDialog(props) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const updateOnboardedCompanyDatas = useSelector(
    (state) => state?.updateCompany?.onBoardedCompay?.data
  );

  const handleClose = () => {
    dispatch(getCompanyData(props?.companyPayload))
    props?.handleClose();
  };

  const handleRateCard = () => {
    navigate('/companies/new-booking', {
      state: { edit: true, companyProfile: updateOnboardedCompanyDatas },
    })
    window.location.reload();
    props?.handleClose();
  }

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={props?.open || false}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <Typography
            variant="head3"
            className="colorPrimary justifyCenter fw600"
          >
            Contract Renewed Successfully
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography>
              Do you want to continue with the same billing cycle and rate card,
              or would you like to update the rate card?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Grid container className="borderTop">
            <Grid item xs={6} className="justifyCenter borderRight">
              <Button
                onClick={handleClose}
                className="font20 fw400 lowercaseButton colorBlack"
              >
                Close
              </Button>
            </Grid>
            <Grid item xs={6} className="justifyCenter">
              <Button
                onClick={handleRateCard}
                className="font20 fw400 lowercaseButton colorBlack"
              >
                Update
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
